import { isEmpty } from '@app/utils/isEmpty';
import { Filter, ProductFilters } from '@typings';
import React from 'react';

import { FiltersPanelGroup } from './FiltersPanelGroup';

interface Props {
  onFilterChange: (newFilters: ProductFilters) => void;
  onToggleFilter: (filterField: string, isExpanded: boolean) => void;
  filters: ProductFilters;
  attributes: Filter.Field<string>[];
  expandedFilters: Record<string, boolean>;
}

export const FiltersPanelGroups = ({ onFilterChange, onToggleFilter, attributes, expandedFilters, filters }: Props) => {
  const validFilterGroups = attributes.filter(({ values }) => !isEmpty(values));

  const handleFilterChange = React.useCallback(
    (fieldName: string, selectedValues: string | string[]) => {
      window.scrollTo({ top: 0 });
      onFilterChange({ [fieldName]: selectedValues });
    },
    [onFilterChange],
  );

  return validFilterGroups.map(attribute => (
    <FiltersPanelGroup
      attribute={attribute}
      key={attribute.field}
      filters={filters}
      onFilterChange={handleFilterChange}
      onToggleFilter={onToggleFilter}
      expandedFilters={expandedFilters}
    />
  ));
};
